import { useState, useEffect, useCallback } from "react";
import { withAppHOC } from "../../../hoc";
import PageHeading from "../../../components/PageHeader/PageHeader";
import OverlayLoader from "../../../components/OverlayLoader/OverlayLoader";
import {
  FormContainer,
  Form,
  Fieldset,
  Label,
  Dropdown,
  MessageBox,
  CreateButton,
  ResetButton,
  Textarea,
} from "../../../components/FormElements";
import API from "../../../api";
import { API_RESPONSE_TYPES } from "../../../constants";

const SendNotifications = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [users, setUsers] = useState([]);
  const [medium, setMedium] = useState("");
  const [notificationType, setNotificationType] = useState("");
  const [usersId, setUsersId] = useState("");
  const [message, setMessage] = useState("");

  const resetForm = () => {
    setMedium("");
    setNotificationType("");
    setUsersId("");
    setMessage("");
  };

  const resetResponseData = () => {
    setIsLoading(false);
    setResponseStatus("");
    setResponseMessage("");
  };

  const readUsers = useCallback(() => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get("/accounts-management/users")
      .then((response) => {
        const { status, message, data } = response.data;
        if (status === API_RESPONSE_TYPES.FAILURE) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          setUsers(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    const formData = {
      medium,
      notificationType,
      usersId,
      message,
    };
    // API.post("/configurations/send-notifications", formData);
    // setIsLoading(false);
    // setResponseStatus(API_RESPONSE_TYPES.SUCCESS);
    // setResponseMessage("Your request is being processed");
    // setTimeout(() => {
    //   setResponseStatus("");
    //   setResponseMessage("");
    // }, 3000);

    API.post(`/configurations/send-notifications`, formData)
      .then((response) => {
        const { status, message } = response.data;
        setResponseStatus(status);
        setResponseMessage(message);
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          resetForm();
          setTimeout(() => {
            resetResponseData();
          }, 3000);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    readUsers();
  }, [readUsers]);

  const usersOptions = [{ title: "-- SELECT USER --", value: "" }];
  if (users && users.length > 0) {
    users.forEach(({ id, fullName }) =>
      usersOptions.push({
        title: fullName,
        value: id,
      })
    );
  }

  return (
    <>
      <PageHeading {...props} />
      <FormContainer>
        <Form method="POST" action="#" onSubmit={onSubmit}>
          <Fieldset>
            <Label required>Medium</Label>
            <Dropdown
              placeholder="Please select medium"
              value={medium}
              onChange={setMedium}
              options={[
                { title: "-- SELECT MEDIUM --", value: "" },
                { title: "Whatsapp", value: "Whatsapp" },
                { title: "SMS", value: "SMS" },
                { title: "Email", value: "Email" },
              ]}
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label required>Notification Type</Label>
            <Dropdown
              placeholder="Please select notification type"
              value={notificationType}
              onChange={setNotificationType}
              options={[
                { title: "-- SELECT NOTIFICATION TYPE --", value: "" },
                { title: "Complaint", value: "Complaint" },
                { title: "Pending", value: "Pending" },
                { title: "Seller", value: "Seller" },
                { title: "Others", value: "Others" },
              ]}
              disabled={isLoading}
            />
          </Fieldset>
          {notificationType === "Others" && (
            <Fieldset>
              <Label>User</Label>
              <Dropdown
                placeholder="Please select user"
                value={usersId}
                onChange={setUsersId}
                options={usersOptions}
                disabled={isLoading}
              />
            </Fieldset>
          )}
          <Fieldset>
            <Label required>Message</Label>
            <Textarea
              placeholder="Please enter message"
              value={message}
              onChange={(e) => {
                setMessage(e.target.value);
              }}
              disabled={isLoading}
            />
          </Fieldset>
          {responseStatus && (
            <Fieldset>
              <MessageBox status={responseStatus} message={responseMessage} />
            </Fieldset>
          )}
          <Fieldset>
            <CreateButton disabled={isLoading === true} type="submit">
              Send
            </CreateButton>
            <ResetButton
              disabled={isLoading === true}
              type="button"
              onClick={resetForm}
            >
              Reset
            </ResetButton>
          </Fieldset>
        </Form>
        <OverlayLoader showLoader={isLoading} />
      </FormContainer>
    </>
  );
};

export default withAppHOC(SendNotifications);
